const gallery = document.querySelector('.gallery');

if (gallery) {
    const media = gallery.querySelectorAll('.media-object');

    if (media.length) {
        [...media].forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();

                const lightBox = document.getElementById('lightbox');

                lightBox.querySelector('#lightbox-image').setAttribute('src', el.closest('a').getAttribute('href'));
                lightBox.querySelector('.lightbox-date').innerText = el.getAttribute('data-date');
                lightBox.style.display = 'flex';

                lightBox.querySelector('#close').addEventListener('click', () => {
                    lightBox.style.display = 'none';
                });

                lightBox.addEventListener('click', e => {
                    if (e.target.id === lightBox.getAttribute('id')) {
                        lightBox.style.display = 'none';
                    }
                })
            });
        });
    }
}
